import { CompRiskLevel } from '@/api';
import { ComplianceTransferData } from '@/redux/models';

export const transfersDemoData: ComplianceTransferData = {
  stats: {
    total: 399572.2,
    income: 129537.48,
    outcome: 270034.72,
    count: 0,
  },
  transfers: {
    txs: [
      {
        key: '1',
        customer: [
          {
            id: '1',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        user: 'User_3',
        txHash:
          '0xda7b34e91a5c8f20b39d1e7a8b9c0a1f2e3d4c5b6a7f8e9d0c1b2a3f4e5d6c7b',
        address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
        counterparty: {
          id: 1,
          name: '',
        },
        direction: 'outcome',
        level: CompRiskLevel.Severe,
        fundsTransferred: 134597.78,
        nextUpdate: '15.08.2025 08:23',
      },
      {
        key: '2',
        customer: [
          {
            id: '2',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        user: 'User_5',
        txHash:
          '7a1b9c0d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c',
        address: '1J7Lz8A9BcN2dV4fG7hJk9Lp3Qr5sT6uVw8xYz2aB',
        counterparty: {
          id: 2,
          name: 'NovaTrade',
        },
        direction: 'income',
        level: CompRiskLevel.High,
        fundsTransferred: 1876.54,
        nextUpdate: '15.08.2025 21:57',
      },
      {
        key: '3',
        customer: [
          {
            id: '3',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        user: 'User_2',
        txHash:
          '0xfa8e29d1c3b5a7f9e2d4c8b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5',
        address: '0x9a8b7c6d5e4f3a2b1c0d9e8f7a6b5c4d3e2f1a0b',
        counterparty: {
          id: 3,
          name: 'CoinLex',
        },
        direction: 'outcome',
        level: CompRiskLevel.Medium,
        fundsTransferred: 2345.67,
        nextUpdate: '15.08.2025 14:05',
      },
      {
        key: '4',
        customer: [
          {
            id: '4',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        user: 'User_5',
        txHash:
          'a9c0b1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0',
        address: 'TDFjx8Z94tsy6ZxLzSjQ7V6d5Y2TGkPQMr',
        counterparty: {
          id: 4,
          name: '',
        },
        direction: 'outcome',
        level: CompRiskLevel.Medium,
        fundsTransferred: 4567.89,
        nextUpdate: '15.08.2025 03:11',
      },
      {
        key: '5',
        customer: [
          {
            id: '5',
            name: 'User_1',
            identifier: 'User_1',
            level: 'medium',
          },
        ],
        user: 'User_1',
        txHash:
          'b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d',
        address: '1AcBdCeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkL',
        counterparty: {
          id: 5,
          name: '',
        },
        direction: 'outcome',
        level: CompRiskLevel.Low,
        fundsTransferred: 2789.12,
        nextUpdate: '15.08.2025 18:49',
      },
      {
        key: '6',
        customer: [
          {
            id: '6',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        user: 'User_3',
        txHash:
          '0x3c6a9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c',
        address: '0x2f4e6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a',
        counterparty: {
          id: 6,
          name: 'ApeXchange',
        },
        direction: 'income',
        level: CompRiskLevel.High,
        fundsTransferred: 98765.43,
        nextUpdate: '15.08.2025 05:36',
      },
      {
        key: '7',
        customer: [
          {
            id: '7',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        user: 'User_2',
        txHash:
          'c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e',
        address: '1Q5R7sT9uVwXyZa1bCdEfGhJkLmNoPqRsTuVwXyZ',
        counterparty: {
          id: 7,
          name: '',
        },
        direction: 'income',
        level: CompRiskLevel.High,
        fundsTransferred: 3456.78,
        nextUpdate: '15.08.2025 23:01',
      },
      {
        key: '8',
        customer: [
          {
            id: '8',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        user: 'User_5',
        txHash:
          '0xef8d2c4b6a0e9d1c3b5a7f9e2d4c8b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c',
        address: '0x5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d',
        counterparty: {
          id: 8,
          name: 'BitMarket Pro',
        },
        direction: 'outcome',
        level: CompRiskLevel.Medium,
        fundsTransferred: 1234.56,
        nextUpdate: '15.08.2025 16:28',
      },
      {
        key: '9',
        customer: [
          {
            id: '9',
            name: 'User_4',
            identifier: 'User_4',
            level: 'medium',
          },
        ],
        user: 'User_4',
        txHash:
          'd2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e2',
        address: 'TZg9R4Lm6WxE7NkYSrA1B2cD3EFgHiJkL',
        counterparty: {
          id: 9,
          name: '',
        },
        direction: 'outcome',
        level: CompRiskLevel.Medium,
        fundsTransferred: 9959.4,
        nextUpdate: '15.08.2025 12:14',
      },
      {
        key: '10',
        customer: [
          {
            id: '10',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        user: 'User_2',
        txHash: 'e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e2f',
        address: '1Lp3Qr5sT6uVwXyZaBcDeFgHiJkLmNoPqRsTu',
        counterparty: {
          id: 10,
          name: 'TokenSwap',
        },
        direction: 'income',
        level: CompRiskLevel.High,
        fundsTransferred: 3876.54,
        nextUpdate: '15.08.2025 09:59',
      },
      {
        key: '11',
        customer: [
          {
            id: '11',
            name: 'User_1',
            identifier: 'User_1',
            level: 'medium',
          },
        ],
        user: 'User_1',
        txHash: 'f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e2f3',
        address: 'TVxY5zAb1CdEfGhJkLmNoPqRsTuVwXyZaB',
        counterparty: {
          id: 11,
          name: 'CryptoHub',
        },
        direction: 'income',
        level: CompRiskLevel.NA,
        fundsTransferred: 4710.88,
        nextUpdate: '15.08.2025 01:32',
      },
      {
        key: '12',
        customer: [
          {
            id: '12',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        user: 'User_5',
        txHash:
          '1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b',
        address: '1gHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmNoPqR',
        counterparty: {
          id: 12,
          name: '',
        },
        direction: 'outcome',
        level: CompRiskLevel.High,
        fundsTransferred: 987.65,
        nextUpdate: '15.08.2025 19:08',
      },
      {
        key: '13',
        customer: [
          {
            id: '13',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        user: 'User_3',
        txHash:
          '2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3',
        address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
        counterparty: {
          id: 13,
          name: '',
        },
        direction: 'income',
        level: CompRiskLevel.Medium,
        fundsTransferred: 64439.99,
        nextUpdate: '15.08.2025 06:45',
      },
      {
        key: '14',
        customer: [
          {
            id: '14',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        user: 'User_2',
        txHash:
          '3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c',
        address: '1BcDeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmN',
        counterparty: {
          id: 14,
          name: 'ChainFlow',
        },
        direction: 'outcome',
        level: CompRiskLevel.Low,
        fundsTransferred: 1820.99,
        nextUpdate: '15.08.2025 20:33',
      },
      {
        key: '15',
        customer: [
          {
            id: '15',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        user: 'User_5',
        txHash:
          '0x4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d',
        address: '0xa9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e6d8c0',
        counterparty: {
          id: 15,
          name: '',
        },
        direction: 'income',
        level: CompRiskLevel.High,
        fundsTransferred: 3915.57,
        nextUpdate: '15.08.2025 11:22',
      },
    ],

    total: 15,
  },
};
